import React from "react";
import "./challenges.css";
import ChallengesCard from "./ChallengesCard";
import QuestLabs from "../../../../components/QuestLabs";
import { challengesBadge } from "../../../../assets/images";
import { ChallengesShowProps } from "../types/Challenges.type";
import { ChallengesBadge } from "./TaskLogo";

const ChallengesShow: React.FC<ChallengesShowProps> = ({
  suggestions,
  setSearchTerm,
  themeManager,
  showCoin,
  completedActionIcon,
  incompletedActionIcon,
  campaignXp,
  showCredits,
  isGradientBackground,
  gradientBackgroundColor,
  showSvg = true,
  customSvg,
  showFooter = true,
}) => {
  return (
    <div
      style={{ ...themeManager.getFormStyles(), background: (isGradientBackground && gradientBackgroundColor) ? gradientBackgroundColor : themeManager.getFormStyles().background, }}
      className="q_challenges_main_cont"
    >
      <div
        style={themeManager?.getMainHeadingStyles()}
        className="q_challenges_main_heading"
      >
        Challenges
      </div>
      <div className="q_challenges_card_main_container">
        {showSvg && <div className="q_top_challenges_card_main_cont">
          <div className="q_top_challenges_card_img">
            {customSvg || <ChallengesBadge primary={themeManager.getChallengesSvgColors().primary} secondary={themeManager.getChallengesSvgColors().secondary} tertiary={themeManager.getChallengesSvgColors().tertiary} />}
          </div>
        </div>}

        <ChallengesCard
          suggestions={suggestions}
          setSearchTerm={setSearchTerm}
          themeManager={themeManager}
          completedActionIcon={completedActionIcon}
          incompletedActionIcon={incompletedActionIcon}
          showCoin={showCoin}
          campaignXp={campaignXp}
          showCredits={showCredits}
        />
      </div>

      {showFooter && <div className="q_footer_challenges">
        <QuestLabs
          style={themeManager.getFooterStyles()}
          textStyle={themeManager.getFooterTextStyle()}
          iconStyle={themeManager.getFooterIconStyles()}
          text={themeManager.getFooterText()}
          link={themeManager.getFooterLinkStyles()}
        />
      </div>}
    </div>
  );
};

export default ChallengesShow;
